import { useMemo } from 'react';
import { PROXY_VIDEO_LABELS } from '@/components/Packaging/constants';
import { InventoryFileEntity } from '@/redux/slices/slice_types';
import { useAppSelector } from '@/redux/hooks';
import { selectTitle } from '@/redux/selectors/orderPlacementSelectors';

type ProxyLabel = (typeof PROXY_VIDEO_LABELS)[number];

export const useGetFilteredInventory = () => {
  const inventory: InventoryFileEntity[] | Record<never, unknown> = useAppSelector(selectTitle);

  const filteredInventory = useMemo(() => {
    return Array.isArray(inventory)
      ? inventory.filter((file) => {
          // we want to show only master files in the list
          const isProxy = PROXY_VIDEO_LABELS.includes(file.label as ProxyLabel);
          return !isProxy;
        })
      : [];
  }, [inventory]);

  return filteredInventory;
};
